import client from "../server/Client";
import {useMutation} from "@tanstack/react-query";

const submit = (payload) => client.post('forms', payload);
export const useSubmitForm = (payload) => useMutation(['submitRequest'], () => submit(payload))